import {isHighSchoolStudent} from 'src/utils/user-type-utils';

const validateEligibilityStep = (values) => {
  const errors = {};

  if (!values.addressLine1) {
    errors.addressLine1 = 'Address is required.';
  }

  if (!values.country) {
    errors.country = 'Country is required.';
  }

  if (!values.city) {
    errors.city = 'City is required.';
  }

  if (values.country === 'US') {
    // This will test for a 5 digit or 5 plus 4 digit code
    if (!/^\d{5}(-\d{4})?$/.test(values.postalCode)) {
      errors.postalCode = 'Please enter a valid postal code.';
    }

    if (!values.subdivision) {
      errors.subdivision = 'State is required.';
    }
  }

  if (values.isUsCitizenOrResident === undefined) {
    errors.isUsCitizenOrResident = 'Citizenship status is required.';
  }

  if (!values.highSchoolInfo.graduationYear && isHighSchoolStudent(values.educationPhase)) {
    errors.highSchoolInfo = {};
    errors.highSchoolInfo.graduationYear = 'Graduation year is required.';
  }

  const hasRequiredValues = values.currentInstitution?.parentId && values.currentInstitution?.name;
  if (!hasRequiredValues) {
    errors.currentInstitution = 'School is required.';
  }

  return Object.keys(errors).length ? errors : {};
};

export default validateEligibilityStep;
